import { createStore } from 'redux';
import CR from './../Reducers/index2'

export const themecolors = createStore(CR).getState().themecolors;